import { createWebHistory, createRouter } from "vue-router";
import Login from "@/views/Login.vue";
import NoAccount from "@/views/NoAccount.vue";
import Register from "@/views/Register.vue";
import UserProfile from "@/views/UserProfile.vue";
import SearchGrants from "@/views/SearchGrants.vue";
import News from "@/views/News.vue";
import GrantDetails from "@/views/GrantDetails.vue";
import Unauthorized from "@/views/Unauthorized.vue";
import NewsDetails from "@/views/NewsDetails";
import ResetPassword from "@/views/ResetPassword.vue";
import NewPassword from "@/views/NewPassword.vue";
import HomePage from "@/views/HomePage.vue";
import DeadlinesSchemes from "../components/homepage-components/DeadlinesSchemes.vue";
import NewestSchemes from "../components/homepage-components/NewestSchemes.vue";
import LatestNews from "../components/homepage-components/LatestNews.vue";
import SignificantChanges from "../components/homepage-components/SignificantChanges";
import store from "../store/index";
import PublicNewsDetails from "@/views/PublicNewsDetails.vue";
import PublicSchemeDetails from "@/views/PublicSchemeDetails.vue";
import SalesForce from "@/views/SalesForce.vue";
import SalesForceUnsubscribe from "@/views/SalesForceUnsubscribe.vue";
import SalesForceCallback from "@/views/SalesForceCallback.vue";
import NewsSelectFinal from "@/components/news-select-components/NewsSelectFinal.vue";
import NewsSelectHome from "@/components/news-select-components/NewsSelectHome.vue";
import NewsForCustomersFinal from "@/components/news-select-components/NewsForCustomersFinal.vue";
import NewsSelectPage from "@/views/NewsSelectPageHubspot.vue";
import OnzePublicNewsList from "@/views/OnzePublicNewsList.vue";
import OnzeExportPage from "@/views/BevindingenHubspot.vue";
import PortalSearchGrants from "@/views/PortalSearchGrants";
import PortalSchemeDetails from "@/components/portals-components/PortalsSchemeDetails.vue";
import TestMailing from "@/views/TestMailing.vue";
import RatingPage from "../views/SurveyPages/RatingPage";
import ReactivationSuggestionPage from "../views/SurveyPages/ReactivationSuggestionPage";
import DeactivationForm from "../views/SurveyPages/DeactivationForm";
import NewUserSuggestionPage from "../views/SurveyPages/NewUserSuggestionPage";
import ErrorPage from "@/views/ErrorPage.vue";
import PortalExpired from "@/views/PortalExpired.vue";
import OidcAuth from "@/views/OidcAuth.vue";
import OidcSignOut from "@/views/OidcSignOut.vue";
import SasTokenAuth from "@/views/SasTokenAuth.vue";
import MfaSetup from "@/views/MfaSetup.vue";
import Mfa from "@/views/Mfa.vue";
import ImpressumPage from "@/views/ImpressumPage.vue";
import ReleaseNotes from "@/views/ReleaseNotes.vue";
import authService from "../services/auth.service";
import { i18nInstance } from "../i18n";

const routes = [
  {
    path: "/",
    component: Login,
    meta: { titleKey: "login.login" },
  },
  {
    path: "/reset-password",
    name: "ResetPassword",
    component: ResetPassword,
    meta: { titleKey: "login.reset_password" },
  },
  {
    path: "/change-password/token=:token(.*)",
    name: "NewPassword",
    component: NewPassword,
    meta: { titleKey: "login.change_password" },
  },
  {
    path: "/register",
    name: "Register",
    component: Register,
    meta: { titleKey: "login.register" },
  },
  {
    path: "/login",
    name: "Login",
    component: Login,
    meta: { titleKey: "login.login" },
  },
  {
    path: "/geen-account",
    name: "NoAccount",
    component: NoAccount,
    meta: { titleKey: "login.no_account" },
  },
  {
    path: "/profile/:tab",
    name: "UserProfile",
    component: UserProfile,
    meta: { titleKey: "profile.profile" },
  },
  /*  {
    path: '/search-grants',
    name: 'SearchGrants',
    component: () => {
      if (isVind.value) return SearchGrants;
      else return PortalSearchGrants;
    },
  }, */
  {
    path: "/search-grants",
    name: "SearchGrants",
    component: SearchGrants,
    meta: { titleKey: "navbar.search_schemes" },
  },
  {
    path: "/search-grants",
    name: "PortalSearchGrants",
    component: PortalSearchGrants,
    meta: { titleKey: "navbar.search_schemes" },
  },
  {
    path: "/news",
    name: "News",
    component: News,
    meta: { titleKey: "navbar.search_news" },
  },
  {
    path: "/grant/:grantId/details:term?",
    name: "GrantDetails",
    component: GrantDetails,
    meta: { titleKey: "scheme_details.scheme_details" },
  },
  {
    path: "/grant/:grantId/details:term?",
    name: "PortalSchemeDetails",
    component: PortalSchemeDetails,
    meta: { titleKey: "scheme_details.scheme_details" },
  },
  {
    path: "/news/view/:newsId",
    name: "NewsDetails",
    component: NewsDetails,
    meta: { titleKey: "news_details.details" },
  },
  {
    path: "/newsletter/view/:newsId",
    name: "NewsletterDetails",
    component: NewsDetails,
    meta: { titleKey: "news_details.details" },
  },
  {
    path: "/unauthorized",
    name: "Unauthorized",
    component: Unauthorized,
  },
  {
    path: "/home-page",
    name: "HomePage",
    component: HomePage,
    meta: { titleKey: "navbar.dashboard" },
  },
  {
    path: "/home-page/deadlines",
    name: "DeadlinesSchemes",
    component: DeadlinesSchemes,
    meta: { titleKey: "my_dashboard.upcoming_deadlines" },
  },
  {
    path: "/home-page/newest",
    name: "NewestSchemes",
    component: NewestSchemes,
    meta: { titleKey: "my_dashboard.latest_schemes" },
  },
  {
    path: "/home-page/latest-news",
    name: "LatestNews",
    component: LatestNews,
    meta: { titleKey: "my_dashboard.latest_news" },
  },
  {
    path: "/home-page/significant-changes",
    name: "SignificantChanges",
    component: SignificantChanges,
  },
  {
    path: "/nieuwsbericht",
    name: "PublicNewsDetails",
    component: PublicNewsDetails,
  },
  {
    path: "/regeling",
    name: "PublicSchemeDetails",
    component: PublicSchemeDetails,
  },
  {
    path: "/onze-bevindingen",
    name: "NewsSelectPage",
    component: NewsSelectPage,
  },
  {
    path: "/onze-bevindingen-uitschrijven",
    name: "SalesForceUnsubscribe",
    component: SalesForceUnsubscribe,
  },
  {
    path: "/salesforce",
    name: "SalesForce",
    component: SalesForce,
  },
  {
    path: "/salesforce/callback",
    name: "SalesForceCallback",
    component: SalesForceCallback,
  },
  {
    path: "/onze-bevindingen/afgerond",
    name: "NewsSelectFinal",
    component: NewsSelectFinal,
  },
  {
    path: "/onze-bevindingen/start",
    name: "NewsSelectHome",
    component: NewsSelectHome,
  },
  {
    path: "/onze-bevindingen/nieuws-afgerond",
    name: "NewsForCustomersFinal",
    component: NewsForCustomersFinal,
  },
  {
    path: "/onze-bevindingen/nieuwsbrief",
    name: "OnzePublicNewsList",
    component: OnzePublicNewsList,
  },
  {
    path: "/onze-bevindingen/:tab",
    name: "OnzeExportPage",
    component: OnzeExportPage,
  },
  {
    path: "/rating/token=:token(.*)/rateValue=:rateValue",
    name: "RatingPage",
    component: RatingPage,
    meta: { titleKey: "navbar.rating" },
  },
  {
    path: "/reactivationSuggestion/token=:token(.*)",
    name: "ReactivationSuggestionsPage",
    component: ReactivationSuggestionPage,
    meta: { titleKey: "navbar.reactivation_suggestion" },
  },
  {
    path: "/deactivation/token=:token(.*)",
    name: "DeactivationForm",
    component: DeactivationForm,
    meta: { titleKey: "navbar.deactivation" },
  },
  {
    path: "/newUserSuggestion/token=:token(.*)",
    name: "NewUserSuggestionPage",
    component: NewUserSuggestionPage,
    meta: { titleKey: "navbar.new_user_suggestion" },
  },
  {
    path: "/mailing",
    name: "Mailing",
    component: TestMailing,
  },
  {
    path: "/error",
    name: "ErrorPage",
    component: ErrorPage,
  },
  {
    path: "/mfa",
    name: "Mfa",
    component: Mfa,
    meta: { titleKey: "login.mfa" },
  },
  {
    path: "/mfa-setup",
    name: "MfaSetup",
    component: MfaSetup,
    meta: { titleKey: "login.login" },
  },
  {
    path: "/portal-expired",
    name: "PortalExpired",
    component: PortalExpired,
    meta: { titleKey: "login.portal_expired" },
  },
  {
    path: "/oidc-auth",
    name: "OidcAuth",
    component: OidcAuth,
  },
  {
    path: "/oidc-signout",
    name: "OidcSignOut",
    component: OidcSignOut,
  },
  {
    path: "/authenticate-by-token",
    name: "AuthByToken",
    component: SasTokenAuth,
  },
  {
    path: "/Impressum",
    name: "ImpressumPage",
    component: ImpressumPage,
    meta: { titleKey: "footer.impressum" },
  },
  {
    path: "/release-notes",
    name: "ReleaseNotes",
    component: ReleaseNotes,
    meta: { titleKey: "release_notes.title" },
  },
];

/* const isVind = computed({
  get: () => store.state.auth.env === 0 || store.state.auth.env === 40,
});
 */
const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
  scrollBehavior(to, from, savedPosition) {
    if (to.hash) {
      const element = document.querySelector(to.hash);
      if (element) {
        const headerOffset = 80;
        const elementPosition = element.offsetTop;
        const offsetPosition = elementPosition - headerOffset;

        window.scrollTo({
          top: offsetPosition,
          behavior: "smooth",
        });

        return false;
      }
    } else if (savedPosition) {
      return savedPosition;
    } else {
      return { top: 0 };
    }
  },
});

router.beforeEach(async (to, from, next) => {
  const publicPages = [
    "/login",
    "/register",
    "/reset-password",
    "/new-password",
    "/change-password",
    "/salesforce",
    "/nieuwsbericht",
    "SalesForce/CallBack",
    "/onze-bevindingen/nieuwsbrief",
    "/onze-bevindingen-uitschrijven",
    "/portal-expired",
    "/rating",
    "/reactivationSuggestion",
    "/deactivation",
    "/newUserSuggestion",
    "/oidc-auth",
    "/oidc-signout",
    "/geen-account",
    "/authenticate-by-token",
    "/regeling",
    "/Impressum",
  ];

  if (i18nInstance) {
    const customerPortalName = store.state.auth.customer.customerPortalName;
    const defaultTitle = customerPortalName
      ? i18nInstance.global.t("navbar.title") + " - " + customerPortalName
      : i18nInstance.global.t("navbar.title");
    let titleKey = to.meta?.titleKey;

    if (to.name === "UserProfile") {
      const tab = to.params.tab;
      const tabTitles = {
        myBasicDetails: "navbar.details",
        newsletter: "navbar.profile_settings_audience",
        newsletterPurposes: "navbar.profile_settings_purposes",
        newsletterLocations: "navbar.profile_settings_locations",
        nieuwsbrief: "navbar.newsletter_settings",
        savedItemsSchemes: "navbar.saved_items",
        savedItemsSearches: "profile.saved_searches",
        hiddenSchemes: "navbar.hidden_schemes",
        accountgegevens: "navbar.account_management",
        gebruikers: "account_management.users",
        gebruik: "profile.user",
        default: titleKey,
      };

      titleKey = tabTitles[tab] || tabTitles.default;
    }
    document.title = titleKey
      ? i18nInstance.global.t(titleKey) + " | " + defaultTitle
      : defaultTitle;
  }

  const routeContainsElementFromPublicPages = publicPages.some((element) => {
    if (to.path.includes(element)) {
      return true;
    }
    return false;
  });
  const authUserId = store.state.auth.authUser.id;

  if (routeContainsElementFromPublicPages) {
    return next();
  }

  if (authUserId) {
    return next();
  }

  // trying to access a restricted page + not logged in
  // redirect to login page
  if (to.path.substring(0, 16) == "/newsletter/view") {
    store.commit("user/setHasComeFromNewsletter", true);
    store.commit("user/setNewsletterParams", to.params);
  }
  try {
    await authService.getAuthUserData();
    next();
  } catch (err) {
    next({
      name: "Login",
      query: { returnUrl: to.fullPath },
    });
  }
});

export default router;


